var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"top-bar"},[_c('div',{staticClass:"content flex flex-row justify-between items-center"},[_c('logo-svg',{staticClass:"logo z-10"}),_c('main-menu',{staticClass:"self-start mt-4"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }